module.exports = __webpack_public_path__ + "img/20230906-094456.63023e4c.webp";